module.exports = __webpack_public_path__ + "img/social-yt.d6c456de.svg";